import { useCallback, useState, useMemo } from 'react';
import { getMaskValueAtPointFunc } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export const useMaskedImage = ({
  imageWidth: originalImageWidth,
}) => {
  const [imageUrlWithoutBackground, setImageUrlWithoutBackground] = useState(null);
  const [imageUrlWithGeneratedBackground, setImageUrlWithGeneratedBackground] = useState(null);
  const [segmentationMasks, setSegmentationMaskInternal] = useState(null);
  const [selectedMasks, setSelectedMasks] = useState([]);
  const [selectedImageSrc, setSelectedImageSrc] = useState(null);
  const [maskSetsBase64, setMaskSetsBase64] = useState(null);

  // mask is encoded in base64 format, decode it here
  const setSegmentationMasks = useCallback(({ maskSetsArray, selectedMasksArray }) => {
    setSegmentationMaskInternal(maskSetsArray);
    setSelectedMasks(selectedMasksArray);
  }, []);

  const maskValues = useMemo(() => Array.from(new Set(segmentationMasks)).filter(x => x > 0), [segmentationMasks]);

  const getMaskValueAtPoint = useCallback((x, y) =>
    getMaskValueAtPointFunc(x, y, originalImageWidth, segmentationMasks), [originalImageWidth, segmentationMasks]);

  return {
    imageUrlWithoutBackground,
    setImageUrlWithoutBackground,
    imageUrlWithGeneratedBackground,
    setImageUrlWithGeneratedBackground,

    // mask
    segmentationMasks,
    setSegmentationMasks,
    getMaskValueAtPoint,
    selectedMasks,
    setSelectedMasks,
    selectedImageSrc,
    setSelectedImageSrc,
    maskSetsBase64,
    maskValues,
    setMaskSetsBase64,
  };
};
